<template>
  <div
    class="reveal delete-confirm-model"
    id="deleteConfirmModal"
    data-reveal
  >
    <div class="delete-modal">
      <p class="font-bold">{{ $t('deleteConfirmMsg') }}</p>
      <div class="btn-group">
        <div
          @click="confirmDelete()"
          class="btn--orange"
        >{{ $t('action.delete') }}</div>
        <div
          @click="cancel()"
          class="btn--darkblue"
        >{{ $t('action.cancel') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'deleteConfirmModel',
  methods: {
    cancel () {
      this.deleteFunction('cancel')
      this.deleteConfirmModal.close()
    },
    confirmDelete () {
      this.deleteFunction()
      this.deleteConfirmModal.close()
    },
    async initModel () {
      if (!this.deleteConfirmModal) {
        this.deleteConfirmModal = await new Foundation.Reveal($('#deleteConfirmModal'), {
          closeOnEsc: false,
          closeOnClick: false,
        })
      }
      this.deleteConfirmModal.open()
    },
    openModal (deleteAction) {
      this.deleteFunction = deleteAction
      this.initModel()
    },
  },
  destroyed () {
    if (this.deleteConfirmModal) {
      this.deleteConfirmModal.destroy()
    }
    $('#deleteConfirmModal').remove()
  },
}
</script>

<style lang="scss" scoped>
.delete-confirm-model {
  height: 140px;
  .delete-modal {
    .btn-group {
      width: 100%;
      position: absolute;
      bottom: 20px;
      right: 0px;
    }
    div {
      float: right;
      display: inline-block;
      width: 90px;
      margin-right: 15px;
    }
  }
  .font-bold {
    font-weight: bold;
  }
}

</style>
